function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -1)",
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.348 2.07L8.902 3.516a.33.33 0 000 .467l1.446 1.446a.33.33 0 00.467 0l.08-.08a.33.33 0 000-.467l-.759-.758a5.35 5.35 0 013.178 1.538A5.413 5.413 0 117.923 4.31L7.7 3.57a6.184 6.184 0 106.16 1.546 6.118 6.118 0 00-3.699-1.768l.732-.732a.33.33 0 000-.467l-.079-.08a.33.33 0 00-.467 0z",
  fill: "#54585D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.318 12.164h4.295a.496.496 0 00.467-.662c-.469-1.318-1.332-1.977-2.588-1.977-1.281 0-2.161.658-2.64 1.974a.496.496 0 00.466.665z",
  stroke: "#54585D",
  strokeWidth: ".723"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#54585D",
  strokeWidth: ".723",
  cx: "9.5",
  cy: "7.848",
  r: "1.239"
}))));